// frontend/src/config/businessLabels.ts
import type { BusinessType } from "../types";

export type { BusinessLabelKey, BusinessLabels } from "../hooks/useBusinessLabels";
export { getBusinessLabels, useBusinessLabels } from "../hooks/useBusinessLabels";

export const BUSINESS_TYPE_OPTIONS: {
  value: BusinessType;
  labelKey: string;
  descriptionKey: string;
}[] = [
  {
    value: "RESTAURANT",
    labelKey: "business.types.RESTAURANT.label",
    descriptionKey: "business.types.RESTAURANT.description",
  },
  {
    value: "BEAUTY",
    labelKey: "business.types.BEAUTY.label",
    descriptionKey: "business.types.BEAUTY.description",
  },
  {
    value: "TATTOO",
    labelKey: "business.types.TATTOO.label",
    descriptionKey: "business.types.TATTOO.description",
  },
  {
    value: "GARAGE",
    labelKey: "business.types.GARAGE.label",
    descriptionKey: "business.types.GARAGE.description",
  },
  {
    value: "OTHER",
    labelKey: "business.types.OTHER.label",
    descriptionKey: "business.types.OTHER.description",
  },
];
